import store from '@/store';

const UserSettings = () => import('@/pages/user/UserSettings');
const UserSettingsIndex = () => import('@/pages/user/UserSettingsIndex');
const UserSettingsOrders = () => import('@/pages/user/UserSettingsOrders');
const UserSettingsProfile = () => import('@/pages/user/UserSettingsProfile');
const UserSettingsPassword = () => import('@/pages/user/UserSettingsPassword');
const UserAdvisoryComment = () => import('@/pages/user/UserAdvisoryComment');

export default {
  path: '/user',
  component: UserSettings,
  redirect: '/user/index',
  children: [
    { 
      path: 'index',
      name: 'userIndex',
      component: UserSettingsIndex,
      meta: {
        title: '會員首頁',
        requiresAuth: true
      }
    },
    { 
      path: 'orders',
      name: 'userOrders',
      component: UserSettingsOrders,
      meta: {
        requiresAuth: true
      }
    },
    { 
      path: 'profile',
      name: 'userProfile',
      component: UserSettingsProfile,
      meta: {
        requiresAuth: true 
      }
    },
    { 
      path: 'password',
      name: 'userPass',
      component: UserSettingsPassword,
      meta: {
        requiresAuth: true 
      }
    },
    {
      path: 'advisory/:id',
      name: 'userAdvi',
      component: UserAdvisoryComment,
      meta: {
        requiresAuth: true
      },
      // beforeEnter() {
      //   console.log(store);
      // },
    }
  ]
};